import * as React from "react"
import { format, parse } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

function DatePicker({ date, onChange, placeholder = "Pick a date", className, disabled }) {
  // Parse date string to Date object if needed
  const dateValue = React.useMemo(() => {
    if (!date) return undefined;
    if (date instanceof Date) return date;
    // Handle YYYY-MM-DD format
    try {
      return parse(date, 'yyyy-MM-dd', new Date());
    } catch {
      return undefined;
    }
  }, [date]);

  const handleSelect = (selectedDate) => {
    if (selectedDate) {
      // Return in YYYY-MM-DD format for consistency with existing code
      const formatted = format(selectedDate, 'yyyy-MM-dd');
      onChange({ target: { value: formatted } });
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          disabled={disabled}
          className={cn(
            "justify-start text-left font-normal",
            !dateValue && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {dateValue ? format(dateValue, "dd-MM-yyyy") : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={dateValue}
          onSelect={handleSelect}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}

export { DatePicker }
